<template>
    <div class="ui-post-item" v-if="item" :class="['ui-post-item-' + item.type]">
        <router-link class="item" :to="item.url">
            <div class="image">
                <img :src="item.featured_image.medium_4x3">
            </div>
            <div class="info">
                <h2 class="title" v-html="item.title.rendered"></h2>
                <span v-if="item.author_name">{{item.author_name}}</span>
            </div>
        </router-link>
    </div>
</template>

<script>



export default {
    name: 'post-item',

    props: {
        item: Object,
    },

}

</script>
<style lang="scss">
    .ui-post-item {
        padding: var(--padding);
        width: 33.33%;
        box-sizing: border-box;

        a,
        a:hover,
        a:visited {
            color: var(--font-color);
        }

        .item {
            display: block;

            img {
                display: block;
                width: 100%;
                height: auto;
            }

            .title {
                text-align: center;
                padding: var(--padding-50) 0 0;
                text-transform: uppercase;
            }
        }

        &.ui-post-item-writing {
            a {
                display: block;
                position: relative;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    background: black;
                    opacity: .35;
                }
            }

            .info {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                color: white;
                box-sizing: border-box;
                padding: var(--padding);
                display: flex;
                justify-content: center;

                h2 {
                    padding-top: 7.5rem;
                }

                span {
                    position: absolute;
                    left: 0;
                    bottom: var(--padding);
                    width: 100%;
                    text-align: center;
                }
            }
            
        }
    }
</style>